export default __webpack_public_path__ + "static/media/Rohit_Jaiswal_Operations - 235_ROHIT JAISWAL.313cc87e.jpeg";